/* eslint-disable prefer-rest-params */
/* eslint-disable unicorn/prefer-spread */
/* eslint-disable sonarjs/no-identical-functions */
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2020. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
// eslint-disable-next-line import/no-extraneous-dependencies
import debounce from 'lodash.debounce';
import { EnvUtils, RESTService } from '@spm/core';
// eslint-disable-next-line import/no-unresolved
import translations from './messages';

/** Number of characters needed to start requesting to the service. */
const QUERY_CHAR_NUMBER = 3;


const newComboBoxOption = item => {
  const { providerName,providerId } = item;
 
  return {
    id: providerId,
    value: providerName,
    item: {
      
      "funeralHome": providerName,   
     
    }   
  };
};

/** Wraps in a promise the call function * */
const getCall = (url, params) => new Promise(resolve => {
    RESTService.get(url, (success, response) => resolve({ success, response }), params);
  });

/** Gets API Call configuration * */
const getConfiguration = () => JSON.parse(EnvUtils.getEnvironmentProperty('REACT_APP_ADDRESS_API'));
const getRestConfiguration  = EnvUtils.getEnvironmentProperty('REACT_APP_REST_URL');
async function getProviders(query, intl, filterCriteria) {
  const env = getConfiguration();
  let url=null;
  // eslint-disable-next-line no-const-assign
// url = window.location.host.includes('localhost') ? getRestConfiguration+env.url : env.url;
 url = getRestConfiguration+env.url; 
 console.log(env.url);
 console.log(getRestConfiguration);
 console.log( window.location.host);
 console.log( url);
  
  try {
    const responseWS = getCall(url, query);

    return responseWS.then(({ success, response }) => {
      if (!success) {
        // eslint-disable-next-line no-console
        console.warn(intl.formatMessage(translations.Utils_Provider_Search_API_Error_No_Records));
      } else {
        const filteredData = response.dtls.filter(filterCriteria);
        const maxResultsData =
          env.maxResults <= 0 ? filteredData : filteredData.slice(0, env.maxResults);
        return maxResultsData.map(newComboBoxOption);
      }
      return [];
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn(intl.formatMessage(translations.Utils_Provider_Search_API_Error_Generic), error);
  }
  return [];
}



/**
 * Custom function for ComboBox element, it searches providers.
 * If the configuration is  not enable it will not trigger a search request.
 *
 * @param {Array} args
 * @returns Array of providers matching the Key.
 */
async function asyncSearchProviders(args) {
  const fullProviderName = args[0];
  const intl = args[1];
  const filterCriteria = args[2] === undefined ? () => true : args[2];
  // eslint-disable-next-line no-unused-vars
  const manualEntry = {
    id: '-2',
    label: intl.formatMessage(translations.Utils_Provider_Search_Combo_Box_Manual_Option),
    value: ' ',
    position: 'bottom',
  };
  let items = [];
  if (fullProviderName.length >= QUERY_CHAR_NUMBER) {
    
    

      const query = { providerNameInputString: fullProviderName };
      items = await getProviders(query, intl, filterCriteria);
  
    return {
      // newItem: manualEntry,
      items,
    };
  }
  return {};
}

/**
 * Define a debounce version of the search function.
 *
 * @returns Array of providers matching the providerKey.
 */
const debouncedSearchProviders = debounce(asyncSearchProviders, getConfiguration().debounceWait, {
  leading: true,
  trailing: false,
  maxWait: 600,
});


function searchProvider() {
  // IE11 does not accept destructuring.
  // eslint-disable-next-line prefer-rest-params
   return debouncedSearchProviders(arguments);
  
}
// eslint-disable-next-line import/prefer-default-export
export { searchProvider };
